<template>
  <div class="slideout-link-item">
    <a v-if="item.url" :href="item.url">
      {{ item.label }}
    </a>
    <b-button v-if="item.links" @click="toggle">
      <b-icon icon="menu-down" v-bind:class="{ active: isActive }" />
    </b-button>
  </div>
</template>

<script>
export default {
  name: "SlideoutNavItem",
  data() {
    return {
      isActive: false
    };
  },
  props: {
    item: Object
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    }
  }
};
</script>
